
import React from 'react';
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, CardContent } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Trash2 } from "lucide-react";
import { DebtItem as DebtItemType } from './debtCalculatorTypes';

interface DebtItemProps {
  debt: DebtItemType;
  index: number;
  updateDebt: (id: string, field: keyof DebtItemType, value: string | number) => void;
  removeDebt: (id: string) => void;
}

const DebtItem: React.FC<DebtItemProps> = ({ debt, index, updateDebt, removeDebt }) => {
  return (
    <Card key={debt.id}>
      <CardContent className="p-4">
        <div className="flex items-center justify-between mb-3">
          <div className="font-medium">Debt #{index + 1}</div>
          <Button 
            variant="ghost" 
            size="sm"
            onClick={() => removeDebt(debt.id)}
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
        
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <div className="space-y-2">
            <Label htmlFor={`name-${debt.id}`}>Description</Label>
            <Input
              id={`name-${debt.id}`}
              value={debt.name}
              onChange={(e) => updateDebt(debt.id, 'name', e.target.value)}
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor={`balance-${debt.id}`}>Balance ($)</Label>
            <Input
              id={`balance-${debt.id}`}
              type="number"
              value={debt.balance}
              onChange={(e) => updateDebt(debt.id, 'balance', e.target.value)}
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor={`rate-${debt.id}`}>Interest Rate (%)</Label>
            <Input
              id={`rate-${debt.id}`}
              type="number"
              value={debt.interestRate}
              onChange={(e) => updateDebt(debt.id, 'interestRate', e.target.value)}
              step="0.01"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor={`payment-${debt.id}`}>Minimum Payment ($)</Label>
            <Input
              id={`payment-${debt.id}`}
              type="number"
              value={debt.minPayment}
              onChange={(e) => updateDebt(debt.id, 'minPayment', e.target.value)}
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default DebtItem;
